import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Tree, Icon, Input } from 'antd'

import { categories } from '@services/api'

import * as style from './style.scss'

@inject((store: any) => {
    const { categoriesStore, popupStore } = store
    return { categoriesStore, popupStore }
})
@observer
class List extends Component<any, any> {
    state = {
        loading: true,
        filterd: [],
        filteredParents: {},
        expandedCats: [],
        dragTo: null
    }

    handleEditCategory = async id => {
        const { data: category } = await categories.getCategory(id)
        await this.props.categoriesStore.updateSelectedByCategory(category.parent_id)
        this.props.popupStore.togglePopup('category', category)
    }

    handleAddSubCategory = async id => {
        await this.props.categoriesStore.updateSelectedByCategory(id)
        this.props.popupStore.togglePopup('category', { parent_id: id, name: null, is_private: null })
    }

    handleLinkedCategories = async id => {
        await this.props.categoriesStore.getRelatedCategories(id)
        this.props.popupStore.togglePopup('linkedCategories', { id })
    }

    handleDragTo = dragTo => {
        this.setState({ dragTo })
    }

    handleDropCategory = dragFrom => {
        const { dragTo } = this.state
        this.props.popupStore.togglePopup('moveCategory', { dragFrom, dragTo })
    }

    render() {
        const { expandedCats, filterd, filteredParents, categoriesStore } = this.props
        const { TreeNode } = Tree
        const treeNodeStyle = {
            width: '100%',
            padding: '0.8rem 0 0.4rem',
            margin: '0.5rem 0 0'
        }

        const generateNodes = catList =>
            catList.map((category, index) => (
                <TreeNode
                    key={category.id}
                    selectable={false}
                    style={{ ...treeNodeStyle, borderTop: `${index === 0 ? 'none' : '1px solid #e4e4e4'}` }}
                    title={
                        <div className={style.node_el}>
                            <div
                                onClick={() => this.handleEditCategory(category.id)}
                                style={{
                                    fontSize: '1rem',
                                    display: 'inline-block',
                                    backgroundColor: `${category.selected ? '#f8d1a0' : 'initial'}`,
                                    padding: '0 0.5rem'
                                }}
                            >
                                <strong>{category.name}</strong> <small>| מזהה: {category.id}</small>
                            </div>
                            {categoriesStore.editing ? (
                                <a
                                    style={{ color: '#e77910', textDecoration: 'underline' }}
                                    onClick={() => this.handleAddSubCategory(category.id)}
                                    className={style.plus_link}
                                >
                                    הוסף תת קטגוריה+
                                </a>
                            ) : (
                                ''
                            )}
                            <a
                                style={{ color: '#e77910', textDecoration: 'underline', marginRight: '0.5rem' }}
                                onClick={() => this.handleLinkedCategories(category.id)}
                                className={style.plus_link}
                            >
                                קטגוריות מקושרות
                            </a>
                        </div>
                    }
                >
                    {!!filteredParents[category.id] && generateNodes(filteredParents[category.id])}
                </TreeNode>
            ))

        const startNodes =
            filterd.length > 0 ? (
                generateNodes(filterd.filter(cat => !cat.parent_id))
            ) : (
                <TreeNode key="0" style={treeNodeStyle} title={<div>אין תוצאות...</div>} />
            )

        return (
            <Fragment>
                <Tree
                    className="draggable-tree"
                    draggable={categoriesStore.editing}
                    onDragLeave={e => this.handleDragTo(e.node.props.eventKey)}
                    onDrop={e => this.handleDropCategory(e.dragNodesKeys[e.dragNodesKeys.length - 1])}
                    switcherIcon={<Icon type="down" />}
                    onExpand={e => this.props.setExpanded(e)}
                    expandedKeys={expandedCats}
                    autoExpandParent={true}
                >
                    {startNodes}
                </Tree>
            </Fragment>
        )
    }
}

export default withRouter(List)
